module.exports = __webpack_public_path__ + "img/logoASA.d068a5f8.png";